import React from "react";
import PageLayout from "../../components/PageLayout";
import OBHavingTroubleCard from "../onboarding/_components/OBHavingTroubleCard";

import EditProfileMainWrapper from "./components/EditProfileMainWrapper";

function EditProfileMain() {
  return (
    <PageLayout>
      <section className="d-flex flex-1xl-nowrap flex-column flex-wrap flex-xl-row align-items-start gap-3 product-listing-main-wrapper-section">
        <EditProfileMainWrapper />
        {/* <OBHavingTroubleCard /> */}
      </section>
    </PageLayout>
  );
}

export default EditProfileMain;
